import LoadingSpinner from 'shared/ui/LoadingSpinner'
import ParticipationHistory from 'shared/ui/ParticipationHistory'
import TicketInfo from 'shared/ui/TicketInfo'
import TournamentInfo from 'shared/ui/TournamentInfo'
import {isStaringSoon} from 'shared/utils/eventUtils'

const TournamentSection = ({scanData, refetch, isLoading}) => {
	const eventData = scanData?.eligible_competitions[0] || {}
	const isStartingSoon = isStaringSoon(eventData)

	return (
		<>
			{/* Tournament Information */}
			<TournamentInfo
				tournamentName={eventData?.event_name || '-'}
				data={eventData}
				refetch={refetch}
				isLoading={isLoading}
			/>

			{/* Ticket Information */}
			<TicketInfo
				ticketName={eventData?.event_name}
				data={eventData}
				isStartingSoon={isStartingSoon}
			/>

			{/*  Participation history*/}
			<ParticipationHistory
				data={eventData?.participation_history?.participation_map}
			/>

			{isLoading && <LoadingSpinner.Overlay size='large' />}
		</>
	)
}

export default TournamentSection
